module.exports = __webpack_public_path__ + "img/4th_anniv.8bbfc05c.jpg";